/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */


export class LogSourceLocationSplunkDdss {
  /**
  * S3 prefix where Splunk DDSS archives are stored.
  */
  'prefix'?: string;
  /**
  * Splunk index name.
  */
  'indexName'?: string;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "prefix",
      "baseName": "prefix",
      "type": "string",
      "format": ""
    },
    {
      "name": "indexName",
      "baseName": "indexName",
      "type": "string",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return LogSourceLocationSplunkDdss.attributeTypeMap;
  }

  public constructor() {
  }
}

